import React, { useContext, useEffect, useState, useRef } from 'react'
import { Helmet } from 'react-helmet'
import { withPrefix } from 'gatsby'
import ReactPlayer from 'react-player'

import {
  GlobalStateContext,
  GlobalDispatchContext,
} from '../context/GlobalContextProvider'
import {
  TopNav,
  BottomNav,
  useSiteMetadata,
  RecordedMixInfoDisplay,
  RecordedMixPlayerImage,
  RadioPlayerPlayButton,
  LoadingScreen,
} from '../components'
import { setHelmetSiteTitling } from '../utils'
import '../styles/index.scss'
import { handleEnded, handleMixReady } from '../dispatch'
import { BottomNavMixWrapper } from './BottomNavMixWrapper'

export default function TemplateWrapper({ children }) {
  const {
    title: siteTitle,
    description,
    siteUrl,
    twitterUsername,
  } = useSiteMetadata()
  const globalState = useContext(GlobalStateContext)
  const { title, resident, live } = globalState
  const [nowPlayingInfo, setNowPlayingInfo] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  /**
   * @category useEffect
   * @name processNowPlayingInfo
   */
  useEffect(() => {
    const processNowPlayingInfo = () => {
      if (globalState) {
        let titling = setHelmetSiteTitling(globalState)
        setNowPlayingInfo(titling)
      }
    }
    processNowPlayingInfo()
  }, [globalState])

  /**
   * @category useEffect
   * @name handleLoading
   */
  useEffect(() => {
    // Function to hide loading screen
    const hideLoading = () => {
      setIsLoading(false)
    }

    // Check if the page is already loaded
    if (document.readyState === 'complete') {
      // hideLoading();
    }

    // Listen for both load and DOMContentLoaded events
    window.addEventListener('load', hideLoading)
    document.addEventListener('DOMContentLoaded', hideLoading)

    // Also hide loading screen after a maximum time (5 seconds)
    // This is a fallback in case the events don't fire properly
    const timeoutId = setTimeout(hideLoading, 5000)

    return () => {
      window.removeEventListener('load', hideLoading)
      document.removeEventListener('DOMContentLoaded', hideLoading)
      clearTimeout(timeoutId)
    }
  }, [])

  return (
    <>
      <Helmet defer={false}>
        <html lang="en" />
        <title>
          {nowPlayingInfo
            ? `${nowPlayingInfo}`
            : `${siteTitle} | Ears to the concrete.`}
        </title>
        <meta name="description" content={description} />
        <meta name="theme-color" content="#f600ff" />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix('/')}img/head/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/head/favicon-16x16.png`}
          sizes="16x16"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/head/favicon-32x32.png`}
          sizes="32x32"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
          color="#f600ff"
        />

        <meta property="og:type" content="music.radio_station" />
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={siteUrl} />
        <meta
          property="og:image"
          content={`${withPrefix('/')}img/halfmoon_3d.png`}
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={siteTitle} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:site" content={twitterUsername} />
        <meta
          name="twitter:image"
          content={`${withPrefix('/')}img/halfmoon_3d.png`}
        />
      </Helmet>
      {isLoading && <LoadingScreen />}
      <TopNav />
      {children}
      <BottomNav />
      <BottomNavMixWrapper />
    </>
  )
}
